import Util from "./Util";
const userData = window.userData;

const listOption = (_option) => {
  const defaultOption = {
    isUuid: true,
    type: 'list',
    board:_option.board,
    isWrite: _option.isWrite,
    isListView:true,
    isCardView: true,
    isListCount: true,
    isMyProfile: true,
    isInfinite: true,
    isTopNotice: false,
    onHookWriteBefore: Util.hookWriteBefore
  }
  let option = {};
  let categoryNull = (_option.categoryId == '') ? true : false;
  switch ( _option.board) {
    case 'notice':
      option={
        isTopNotice:true,
        isHideCommentToList:true,
        isComment:false,
        isShowListCategory:  categoryNull,
        isLike:false,
        isUsingSearchWriter:false,
        isAdmin: true
      }
      break;
    case 'update':
      option={
        isCategory:false,
        isShowCategoryAll:false,
        isShowListCategory:categoryNull,
        isHideCommentToList:true,
        isComment:false,
        isLike:false,
        isUsingSearchWriter:false,
        isAdmin: true

      }
      break;
    case 'eventlist_running':
      option={
        site: 'bns',
        type: 'thumb',
        isWrite: false,
        isShowSearchForm: false,
        isThumbView: false,
        isDefaultViewMode: 'card',
        isUsingSearchWriter: false,
        listPage: 'running', // 'closed'
        listSize: 12,
        isCategory : false,
        isShowCategoryAll : false,
        isShowListCategory : false,
        isMyProfile: false,
        isLike: false

      }
      break;

    case 'eventlist_closed':
      option={
        site: 'bns',
        type: 'thumb',
        isWrite: false,
        isShowSearchForm: false,
        isThumbView: false,
        isDefaultViewMode: 'card',
        isUsingSearchWriter: false,
        listPage: 'closed', // 'closed'
        listSize: 12,
        isCategory : false,
        isShowCategoryAll : false,
        isShowListCategory : false,
        isMyProfile: false,
        isLike: false,
        setLegacyEventDate:365
      }
      break;
    case 'job':
      option = {
        isCategory: true,
        isShowCategoryAll:  true,
        isShowListCategory:  true,
        isShowCategory1DepthValue:true,
        isShowCategory2Depth: false,
        isTopNotice:true
      };
      break;

    case 'server':
      option = {
        isCategory: true,
        isShowCategoryAll:  true,
        isShowListCategory:  true,
        isShowCategory1DepthValue:true,
        isShowCategory2Depth: true,
        isShowCategory2DepthAll:true,
        isTopNotice:true
      };

      break;

    case 'party':
      option = {
        isCategory: true,
        isShowCategoryAll:  true,
        isShowListCategory:  true,
        isShowCategory1DepthValue:true,
        isShowCategory2Depth: false,
        isTopNotice:true
      };
      break;

    case 'market':
      option = {
        isCategory: true,
        isShowCategoryAll:  true,
        isShowListCategory:  true,
        isShowCategory1DepthValue:true,
        isShowCategory2Depth: false,
        isTopNotice:true
      };
      break;

    case 'member_recruit':
      option = {
        isCategory: true,
        isShowCategoryAll:  true,
        isShowListCategory:  true,
        isShowCategory1DepthValue:true,
        isShowCategory1DepthAll:true,
        isShowCategory2Depth: false,
        isTopNotice:true
      };
      break;
    case 'free':
      option = {
        isShowCategory1DepthValue:true,
        isTopNotice:true
      };
      break;
    case 'image':
      option = {
        isDefaultViewMode:'card',
        isCardView: true,
        isThumbView: true,
        isListView:false,
        isCategory: true,
        isShowCategoryAll:  true,
        isShowListCategory:  true,
        isTopNotice:true
      };
      break;
    case 'library':
      option = {
        isDefaultViewMode:'thumb',
        isCardView: true,
        isThumbView: true,
        writerInfo: 'reserved2',
        isListView:false,
        isHideCommentToList:true,
        isComment:false,
      };
      break;

  }
  return Object.assign(defaultOption, option);
}



const myDefaultOption = {
  isUuid: true,
  type: 'list',
  userGuid: userData.guid,
  isWrite: false,
  isAdmin: false,
  isShowSearchForm: false,
  isListView: false,
  isCardView: false,
  isThumbView: false,
  isDefaultViewMode: 'list',
  isInfinite: true,
  isUsingSearchWriter: true,
  isShowListCategory: true
}
const myBookMarkOption = (_option) => {
  const option = {
    isBookmarkDelete: true,
    listPage: 'bookmark',
    isMyCharacter: _option.isMyCharacter,
    isProfileWithCharId: true,
    serverType:_option.serverType
  }

  return Object.assign({}, myDefaultOption, option);
}
const myBoardOption = (_option) => {
  const option = {
    isArticleDelete: _option.isMyCharacter,
    listPage: 'myboard',
    isMyCharacter: _option.isMyCharacter,
    useAPIListUrl:true,
    serverType:_option.serverType
  }

  return Object.assign({}, myDefaultOption, option);
}
const myCommentOption = (_option) => {
  const option = {
    isArticleDelete: false,
    isProfileWithCharId: true,
    listPage: 'mycomment',
    isMyCharacter:  _option.isMyCharacter,
    serverType:_option.serverType
  }

  return Object.assign({}, myDefaultOption, option);
}

const viewOption = (_option) => {
  const defaultOption = {
    isUuid: true,
    type: 'view',
    board:_option.board,
    isBookmark: true, //true
    bookmarkUrl: '/world/character/' + userData.representativeCharacter.serverType + '/'+ userData.representativeCharacter.serverId +'/' + userData.representativeCharacter.name + '/bookmark',
    isWrite: _option.isWrite,
    isShowPrevNextArticle: true, //false
    useMobileImage: true,// !_option.isWrite,
    isAdmin:!_option.isWrite,
    isShowViewUtil: _option.isWrite,
    isShowSignature: _option.isWrite,
    isMyProfile: _option.isWrite,
    isShare:_option.isShare,
    viewAPIUrl:_option.viewAPIUrl,
    isComment:true,
    isInfinite: true,
    onHookWriteBefore: Util.hookWriteBefore
  }
  let option = {};
  switch ( _option.board) {
    case 'notice':
      option={
        isLike:false,
        checkCategoryId:_option.checkCategoryId,
        isShowPrevNextArticle:false,
        isComment: false
      }
      break;
    case 'update':
      option={
        isLike:false,
        checkCategoryId:_option.checkCategoryId,
        isShowPrevNextArticle:false,
        isComment: false
      }
      break;
    case 'library':
      option = {
        isShowPrevNextNavigation:true,
        isMyProfile:true,
        isComment: false
      };
      break;
    case 'free':
      option = {
        isShowNoticeComment:true
      };
      break;

  }
  return Object.assign(defaultOption, option);
}
const writeOption = (_option) => {
  const defaultOption = {
    isUuid: true,
    site: 'bns',
    board: _option.board,
    isShowCategory : true,
    isEmoticon:true,
    emoticons: commentEmoticon(_option.wstatic),
    isMyProfile: false,
    isShowCategory2Depth: false,
    isShowCategory2DepthAll: true,
    isShowTextToolbar: true,
    allowOnBeforeUnloadAlert: false,
    imageUploadFrameUrl: '/board/common/upload.html',
    isAutoLink:true
  }
  let option = {};
  switch ( _option.board) {
    case 'job':
      option = {
        isShowCategory1DepthValue:true,
        isShowCategory2Depth: false
      };
      break;
    case 'server':
      option = {
        isShowCategory1DepthValue:true,
        isShowCategory2Depth: true
      };
      break;
    case 'free':
      option = {
        isShowWriteCategory:false
      };
      break;
  }
  return Object.assign(defaultOption, option);
}


const commentOption = (_option) =>  {
  let option = {
    isUuid: true,
    board: _option.board,
    defaultCommentProfileImage : _option.defaultCommentProfileImage,
    isCommentUpdate : true, //false
    isCommentUpload:true,
    commentUploadFrame: '/board/common/commentUpload.html',
    commentUploadTokenUrl: _option.commentUploadTokenUrl,
    isCommentEmoticon:true,
    emoticons: commentEmoticon(_option.wstatic),
    adminCommentImg:  _option.adminCommentImg,
    isCommentOrderByAsc:true,
    commentOrderByDefault:'asc'

  };

  return option;
}

const boardOption = (_option = {})=>{
  let option = {}
  switch (_option.boardType) {
    case 'list' :
      option = listOption(_option);
      break;
    case 'myBookMark' :
      option = myBookMarkOption(_option);
      break;
    case 'myBoard' :
      option = myBoardOption(_option);
      break;
    case 'myComment' :
      option = myCommentOption(_option);
      break;
    case 'view' :
      option = viewOption(_option);
      break;
    case 'write' :
      option = writeOption(_option);
      break;
  }


  return option;
}


const commentEmoticon = (_url) => [
  _url+"/resource/bns/emoticon/42.gif",
  _url+"/resource/bns/emoticon/43.gif",
  _url+"/resource/bns/emoticon/44.gif",
  _url+"/resource/bns/emoticon/45.gif",
  _url+"/resource/bns/emoticon/46.gif",
  _url+"/resource/bns/emoticon/47.gif",
  _url+"/resource/bns/emoticon/48.gif",
  _url+"/resource/bns/emoticon/49.gif",
  _url+"/resource/bns/emoticon/50.gif",
  _url+"/resource/bns/emoticon/51.gif",
  _url+"/resource/bns/emoticon/01.gif",
  _url+"/resource/bns/emoticon/02.gif",
  _url+"/resource/bns/emoticon/03.gif",
  _url+"/resource/bns/emoticon/04.gif",
  _url+"/resource/bns/emoticon/05.gif",
  _url+"/resource/bns/emoticon/06.gif",
  _url+"/resource/bns/emoticon/07.gif",
  _url+"/resource/bns/emoticon/08.gif",
  _url+"/resource/bns/emoticon/09.gif",
  _url+"/resource/bns/emoticon/10.gif",
  _url+"/resource/bns/emoticon/11.gif",
  _url+"/resource/bns/emoticon/12.gif",
  _url+"/resource/bns/emoticon/13.gif",
  _url+"/resource/bns/emoticon/14.gif",
  _url+"/resource/bns/emoticon/15.gif",
  _url+"/resource/bns/emoticon/16.gif",
  _url+"/resource/bns/emoticon/17.gif",
  _url+"/resource/bns/emoticon/18.gif",
  _url+"/resource/bns/emoticon/19.gif",
  _url+"/resource/bns/emoticon/20.gif",
  _url+"/resource/bns/emoticon/21.gif",
  _url+"/resource/bns/emoticon/22.gif",
  _url+"/resource/bns/emoticon/23.gif",
  _url+"/resource/bns/emoticon/24.gif",
  _url+"/resource/bns/emoticon/25.gif",
  _url+"/resource/bns/emoticon/26.gif",
  _url+"/resource/bns/emoticon/27.gif",
  _url+"/resource/bns/emoticon/28.gif",
  _url+"/resource/bns/emoticon/29.gif",
  _url+"/resource/bns/emoticon/30.gif",
  _url+"/resource/bns/emoticon/31.gif",
  _url+"/resource/bns/emoticon/32.gif",
  _url+"/resource/bns/emoticon/33.gif",
  _url+"/resource/bns/emoticon/34.gif",
  _url+"/resource/bns/emoticon/35.gif",
  _url+"/resource/bns/emoticon/36.gif",
  _url+"/resource/bns/emoticon/37.gif",
  _url+"/resource/bns/emoticon/38.gif",
  _url+"/resource/bns/emoticon/39.gif",
  _url+"/resource/bns/emoticon/40.gif",
  _url+"/resource/bns/emoticon/41.gif"
];

export {
  boardOption,
  commentOption
}
